module.exports = __webpack_public_path__ + "static/ARTS_120-bf89b9b5f509ac7ebe079090fb4f5413.png";